import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
import soon from "assets/images/ct/soon.png";
import disLine from "assets/images/ct/dis-line.png";
import player from "assets/images/ct/player.png";
import crosspoint from "assets/images/ct/point2.png";
import techcardimage from "assets/images/ct/tech-card-image.png";
import alienscardimage from "assets/images/ct/aliens-card-point.png";
import mythoscardimage from "assets/images/ct/mythos-card-point.png";
import randomcardimage from "assets/images/ct/random-card-point.png";
import schemescardimage from "assets/images/ct/schemes-card-point.png";

const OtherPlayer = ({
  screens,
  isReaderPlayer = false,
  currentPlayerInfo,
  currentPlayerCard,
  currentPlayer,joke=""
}) => {
  const nonactive_title = _.get(
    screens,
    "2_startturn.nonactive.title",
    "Hold Up"
  );
  const nonactive_instructions = _.get(
    screens,
    "2_startturn.nonactive.instructions",
    "It's not your turn - yet. Pay attention to the other players and learn conspiracies."
  );
  const reader_instructions = _.get(
    screens,
    "2_startturn.reader.instructions",

    "If the player lands on a conspiracy tile be prepared to get involved in the investigation. You will read the prompt to the user."
  );
  const reader_title = _.get(
    screens,
    "2_startturn.reader.title",

    "GRILL 'EM"
  );

  const cardImageFunction = (type) => {
    switch (type) {
      case "tech":
        return techcardimage;
      case "mythos":
        return mythoscardimage;
      case "aliens":
        return alienscardimage;
      case "random":
        return randomcardimage;
      default:
        return schemescardimage;
    }
  };
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="other-player"
    >
      <motion.div variants={fadeVariants} className="other-player-flex">
        <img src={soon} className="img-fluid" alt="" />
        <div className="text-right">
          <h4 className="title">{isReaderPlayer ?reader_title : nonactive_title}(</h4>
          <img src={disLine} className="img-fluid disLine" alt="" />
        </div>
      </motion.div>
      <div className="player-card">
        <div className="player-info">
          <div className="img-box">
             <img src={currentPlayer?.profile_image} className="img-fluid" alt="" /> 

          </div>
          <h3 className="name">{currentPlayer?.display_name}</h3>
        </div>
        <div className="point-bg">
          {Object.entries(currentPlayerCard?.cards).map((value, key) => {
            return (
              <div key={value} className="player-points">
                <div className="type">
                  <p>{value[0]}</p>
                </div>
                {value[1] === 0 ? (
                  <div className="points">
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                  </div>
                ) : value[1] === 1 ? (
                  <div className="points">
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                  </div>
                ) : value[1] === 2 ? (
                  <div className="points">
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                    <img src={crosspoint} className="img-fluid icon1" alt="" />
                  </div>
                ) : (
                  <div className="points">
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                    <img
                      src={cardImageFunction(value[0])}
                      className="img-fluid icon1"
                      alt=""
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {isReaderPlayer ? (
          <motion.p variants={fadeVariants} className="info">
           {reader_instructions}
          </motion.p>
        ) : (
          <motion.p variants={fadeVariants} className="info">
            {nonactive_instructions}
          </motion.p>
        )}
        <div className="did-you-know">
          <p className="que">Did you know?</p>
          <p className="ans">{joke}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default OtherPlayer;
